import { createSlice } from '@reduxjs/toolkit';
import { completeRemainingPayments, downloadPaymentsList, getPayments } from './paymentService';

const initialState = {
    payments: {
        isPaymentsLoading: null,
        isPaymentsSuccess: null,
        pageCount: 0,
        payments: [],
        paymentsCount: 0,
    },
    paymentsFile: {
        isFileDownloading: null,
        fileDownloadedMsg: null,
        isFileDownloadSuccess: null
    },
};

const paymentSlice = createSlice({
    name: 'payment',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getPayments.pending, (state) => {
            state.payments = {
                ...initialState.payments,
                isPaymentsLoading: true,
            };
        });

        builder.addCase(getPayments.rejected, (state) => {
            state.payments = {
                ...initialState.payments,
                isPaymentsLoading: false,
                isPaymentsSuccess: false,
            };
        });

        builder.addCase(getPayments.fulfilled, (state, action) => {
            state.payments = {
                ...initialState.payments,
                isPaymentsLoading: false,
                isPaymentsSuccess: true,
                pageCount: action.payload.pageCount || 0,
                payments: action.payload.data || [],
                paymentsCount: action.payload.count || 0,
            };
        });

        //Download Payments
        builder.addCase(downloadPaymentsList.pending, (state) => {
            state.paymentsFile = {
                ...initialState.paymentsFile,
                isFileDownloading: true,
            };
        });

        builder.addCase(downloadPaymentsList.rejected, (state, action) => {
            state.paymentsFile = {
                ...initialState.paymentsFile,
                isFileDownloading: false,
                fileDownloadedMsg: action.payload.message,
                isFileDownloadSuccess: false
            };
        });

        builder.addCase(downloadPaymentsList.fulfilled, (state, action) => {
            state.paymentsFile = {
                ...initialState.paymentsFile,
                isFileDownloading: false,
                fileDownloadedMsg: action.payload.message,
                isFileDownloadSuccess: true
            };
        });
    },
});

export default paymentSlice.reducer;
